import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import Config from './config';
import { ChainId, DefaultChainId, SupportChainIDs } from 'constant';
import { getSdk as getGraphSdk } from './graph/__generated__/request';
import { GraphQLClient } from 'graphql-request';
import { Client } from './type';
import simpleDialog from 'stores/simpleDialog';
import { authStore } from 'stores/authorizationStore';

export function getCurrentChainId(): ChainId {
    const web3ChainId = Number(((window as any)?.web3 as any)?.currentProvider.chainId);

    return SupportChainIDs.indexOf(web3ChainId) >= 0 ? web3ChainId : DefaultChainId;
}

const errorLink = onError(({ networkError, operation, forward }) => {
    console.log(networkError);
    if (networkError && 'statusCode' in networkError && networkError.statusCode === 401) {
        // 清除无效 Token
        authStore.clearToken();
        return;
    }
});

export function getApolloClient(key: string, chainId?: ChainId) {
    console.log('ops client with chain', chainId || getCurrentChainId());
    return new ApolloClient({
        cache: new InMemoryCache(),
        link: from([
            errorLink,
            new HttpLink({
                uri: (Config[chainId || getCurrentChainId()] as any)[key],
            }),
        ]),
    });
}

const sdkWrapper: any = async (
    action: () => Promise<any>,
    operationName: string,
    operationType?: string,
    variables?: any,
): Promise<any> => {
    return action().catch((error) => {
        if (error.__graphqlRequestAuthError) {
            // auth 失败抛出到上层自行处理
            const newError = error.error;
            newError.code = error.code; // 保留原始的 code
            throw newError;
        } else if (error.__graphqlRequestCustomError) {
            // throw custom error
            const newError = error.error;
            newError.code = error.code;
            throw newError;
        }
        // if (variables?._catchError) {
        //     console.error(
        //         'query error, method:',
        //         operationName,
        //         variables || '',
        //     );
        // } else {
        //     throw error;
        //     // console.log(JSON.stringify(error));
        //     // setTimeout(() => {
        //     //   alert.error({
        //     //     title: 'Error',
        //     //     text: error?.response?.errors?.length
        //     //       ? error?.response?.errors[0]?.message
        //     //       : 'Something went wrong.',
        //     //   });
        //     // }, 0);
        // }
    });
};

export function getOnePieceServerApi(auth = false) {
    return getGraphSdk(
        new GraphQLClient((Config[getCurrentChainId()] as any)[Client.onePieceServer], {
            requestMiddleware: async (request) => {
                let token = authStore.token;
                if (auth) {
                    try {
                        token = await authStore.getToken();
                    } catch (error) {
                        setTimeout(() => {
                            simpleDialog.error({
                                title: 'Authorization Required',
                                text: 'Please confirm the authorization in your wallet.',
                            });
                        }, 0);
                        throw {
                            __graphqlRequestAuthError: true,
                            error: new Error('Authorization failed'),
                        };
                    }
                }
                return {
                    ...request,
                    headers: {
                        ...request.headers,
                        authorization: token ? `Bearer ${token}` : '',
                    },
                };
            },
            responseMiddleware: (response: any) => {
                if (response instanceof Error || response.errors) {
                    // Handle Twitter auth failure first
                    if (
                        response?.response?.errors?.[0]?.extensions?.originalError?.statusCode === 400 &&
                        response?.response?.errors?.[0]?.extensions?.originalError?.errorCode === 'TWITTER_AUTH_FAILED'
                    ) {
                        throw {
                            __graphqlRequestAuthError: true,
                            error: new Error('Twitter authorization failed'),
                            code: 'TWITTER_AUTH_FAILED',
                        };
                    }

                    setTimeout(() => {
                        let errorMessage = '';
                        if ((response as any)?.response?.errors && (response as any)?.response?.errors.length) {
                            const error = (response as any)?.response?.errors[0];
                            errorMessage = error?.message || 'Unknown error';
                        } else if ((response as Error).message) {
                            errorMessage = (response as Error).message;
                        } else {
                            errorMessage = 'Something went wrong';
                        }

                        // ignore 'user not found' error
                        if (!/user.*not\sfound/i.test(errorMessage)) {
                            simpleDialog.error({
                                title: 'Error',
                                text: errorMessage,
                            });
                        }
                    }, 0);

                    if (response?.response?.errors[0]?.extensions?.originalError?.statusCode === 401) {
                        // 清除无效 Token
                        authStore.clearToken();
                    }
                }
            },
        }),
        sdkWrapper,
    );
}
